const MARKDOWN_ESCAPE_PATTERN = /[\\`*[\]]/g;

export const escapeMarkdownInline = (value: string): string => {
  return value.replace(MARKDOWN_ESCAPE_PATTERN, '\\$&');
};

export const escapeMarkdownHeading = (value: string): string => {
  return escapeMarkdownInline(value.replace(/\s+/g, ' ').trim());
};

export const escapeMarkdownListValue = (value: string): string => {
  return escapeMarkdownInline(value).replace(/\r?\n/g, ' ');
};

export const isUrlLike = (value?: string | null): boolean => {
  if (!value) {
    return false;
  }

  return /^https?:\/\//i.test(value);
};

export const toMarkdownBlockquote = (value: string): string => {
  return value
    .split(/\r?\n/)
    .map((line) => `> ${line}`)
    .join('\n');
};
